import {
  LinkButton,
  LinkButtonType,
  Modal,
  ModalButtons,
  ModalSize,
  ModalText,
  OHeaderThree,
  Flex,
} from '@lifechurch/react-ion';
import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  body: ReactNode;
  buttonText: string;
  closeModal: () => void;
  callback: () => void;
}

const RiskModal: FC<Props> = ({ body, buttonText, callback, closeModal }) => {
  const { t } = useTranslation('common');
  return (
    <Modal dismiss={closeModal} size={ModalSize.NARROW}>
      <OHeaderThree marginBlockEnd={3}>{t('are_you_sure')}</OHeaderThree>
      <ModalText marginBlockEnd={3}>{body}</ModalText>
      <ModalButtons>
        <Flex justifyContent={'flex-end'} marginBlockStart={3} width={'100%'}>
          <LinkButton buttonType={LinkButtonType.SECONDARY} onClick={closeModal}>
            {t('cancel')}
          </LinkButton>
          <LinkButton buttonType={LinkButtonType.ERROR} marginInlineStart={5} onClick={callback}>
            {buttonText}
          </LinkButton>
        </Flex>
      </ModalButtons>
    </Modal>
  );
};

export default RiskModal;
